import {reactFetchJSON} from '@github-ui/verified-fetch'
import type {GraphQLResponse} from '@github-ui/item-picker-base/api/graphql'
import {buildItemPickersUrl} from '@github-ui/item-picker-base/api/urls'
import {CreateLabel} from '@github-ui/server-persisted-queries'
import type {CreateLabelMutation} from '@github-ui/server-persisted-queries/types/CreateLabel'

export type CreateLabelRequest = {
  repositoryId: string
  name: string
  color: string
  description?: string
}

export type CreateLabelResponse = GraphQLResponse<CreateLabelMutation>

export async function apiCreateLabel(request: CreateLabelRequest): Promise<CreateLabelResponse> {
  const pathname = buildItemPickersUrl('labels')

  const init = {
    method: 'POST',
    body: {...request, queryId: CreateLabel},
  }

  const response = await reactFetchJSON(pathname, init)
  return response.json() as Promise<CreateLabelResponse>
}
